import React, { useState, useEffect } from "react";
import Image from "next/image";

import Item from './item-sparepart'

function AlphaList({ list, type, title, step, filters = true , name, parent, brandUrl, applianceUrl, media}) {

    const [selectedSubFilter, setSelectedSubFilter] = useState(list);

    const storeSelectedVariation = (selected_letter, list) => {

        var result = list.filter(obj => {
            // if the lowercase first letter of the category name matches the lowercase selected letter
            return obj.name.toLowerCase().startsWith(selected_letter.toLowerCase()) 
        })
        // store our selected variation here
        setSelectedSubFilter(result)
    }

    // const alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

    const unnsortedAlphabet = list.map(function (item) {
        // Return the first letter of the title property
        return item.name.toUpperCase().substring(0, 1);
    }).filter(function (value, index, self) {
        // http://stackoverflow.com/a/14438954/1789518
        return self.indexOf(value) === index;
    });

    const alphabet = unnsortedAlphabet.sort();

    useEffect(() => {
      setSelectedSubFilter(list)
    }, [list])
  
    return (
        <>
          <div className="lg:bg-gray-100 bg-white lg:py-8 px-5 pb-5 pt-3 lg:px-0">
            <div
              className={`container mx-auto ${
                !filters && "flex justify-between items-start"
              }`}
            >
              <div>
                <h1 className="font-bold text-4xl text-gray-900 mb-4 capitalize">
                  Step {step}: {step == 1 ? "Select A Brand" : step < 3 ? "Appliance" : "Select Range/Model"}
                </h1>
                {filters ? (
                  <div className="alphabetical-filter ">
                    <h6 className="text-gray-900 text-base font-normal mb-1">
                      Filter {title}:
                    </h6>
                    <div className="lg:flex lg:space-x-2 lg:gap-0 grid grid-cols-6 gap-2">
                      <div
                        className="cursor-pointer rounded border-2 border-gray-800 px-2 lg:w-12 h-12 lg:h-10 w-full text-center py-1 flex flex-col items-center justify-center bg-white text-gray-800 font-bold text-lg"
                        onClick={(e) => {
                          setSelectedSubFilter(list);
                        }}
                      >
                        All
                      </div>
                      {alphabet.map((letter) => (
                        <div
                          key={letter}
                          className="cursor-pointer rounded border px-2 lg:w-12 h-12 lg:h-10 w-full text-center py-1 flex flex-col items-center justify-center bg-white text-gray-900 font-bold text-lg border-white hover:border-brand-secondary active:border-brand-primary transition-all"
                          onClick={(e) => {
                            storeSelectedVariation(letter, list);
                          }}
                        >
                          {letter}
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <p className="text-xs font-medium tracking-tight">
                    {step > 2 ? (
                      <>
                        You have chosen the brand{" "}
                        <span className="font-bold">{parent}</span> and chosen the
                        appliance <span className="font-bold">{name}</span>. Now choose your range/model.
                      </>
                    ) : (
                      <>
                        You have chosen the brand{" "}
                        <span className="font-bold">{parent}</span>. Now choose your{" "}
                        appliance.
                      </>
                    )}
                  </p>
                )}
              </div>
              {!filters && (
                <div>
                  <Image src={media} alt={parent} width={80} height={80} />
                </div>
              )}
            </div>
          </div>
          <div className="py-8 px-5 lg:px-0">
            <div className="container mx-auto">
              {!filters && <h3 className="capitalize mb-8">Choose {step == 1 ? title : step == 2 ? 'Appliance' : step == 3 ? 'Range' : title} </h3>}
              <div className="grid lg:grid-cols-6 grid-cols-2 lg:gap-8 gap-2 lg:mb-10">
                {filters
                  ? selectedSubFilter &&
                    selectedSubFilter.map((item) => (
                      <Item type={type} item={item} key={item.id}></Item>
                    ))
                  : list &&
                    list.map((item) => (
                      <Item
                        type={"sparepart"}
                        brand={"/" + brandUrl}
                        appliance={applianceUrl}
                        item={item}
                        key={item.id}
                      ></Item>
                    ))}
              </div>
            </div>
          </div>
        </>
      );    
}

export default AlphaList;